// Create angular service to get API
angular.module('galilai.creator').factory('api', function($http, $rootScope) {

    let base_url = window.BASE_URL || window.origin

    function getHeaders(token) {
        let headers = {
            'Source': 'extension',
            'App': IS_APP ? 'app': 'web',
            'IAP': $rootScope.IAPEnabled() ? 'enabled' : 'disabled',
            'Request-Id': window.RUN_ID,
        }
        if (token) {
            headers['Authorization'] = 'Bearer ' + token
        }
        return headers
    }

    function streamMethod(endpoint, options, {cbInit, cbProgress, cbFinish, cbError}) {
        let input = options.input
        let method = options.method || 'POST'
        let outputType = options.output || 'json'
        let token = localStorage.getItem('auth.token')
        let currentReader = null;
        let params = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        }
        if (method == 'POST' && input) {
            params.body = JSON.stringify(input)
        }
        fetch(endpoint, params)
        .then((response) => {
            // Ready and print each chunk of data (text ) to console
            const reader = response.body.getReader();
            cbInit(currentReader)
            // Destroy the reader when the stream is done
            let readStream = (reader) => {
                return reader.read().then(({ done, value }) => {
                    if (done) {
                        cbFinish(null, null, true, reader)
                        cbProgress(null, null, true, reader)
                        return;
                    }
                    let textValue = new TextDecoder("utf-8").decode(value)

                    try {
                        let errorMessage = JSON.parse(textValue)
                        if (errorMessage.error) {
                            cbError(errorMessage, null, true, reader)
                            return
                        }
                    } catch(err) {}

                    console.log('[API] Stream:', textValue)
                    try {
                        if (textValue.trim().indexOf('[DONE]') != -1) {
                            let newText = textValue.replace('[DONE]', '')
                            cbProgress(null, newText, true, reader)
                            cbFinish(null, null, true, reader)
                            return
                        } else {
                            let newText = textValue.replace('[DONE]', '')
                            if (outputType == 'json') {
                                try {
                                    let parsedJson = JSON.parse(newText)
                                    console.log('[API] Parsed JSON:', parsedJson)
                                    cbProgress(null, parsedJson, false, reader)
                                } catch (err) {
                                    console.log('Error parsing JSON [API]', newText)
                                    logError({
                                        message: 'Error parsing generated JSON',
                                        error: err,
                                        data: newText
                                    })
                                }
                            } else {
                                cbProgress(null, newText, false, reader)
                            }
                        }
                    } catch (err) {
                        cbFinish(err, null, true, reader)
                        cbError(err, null, true, reader)
                        return
                    }
                    return readStream(reader);
                });
            }
            // Reader error event
            reader.onerror = (error) => {
                cbFinish(error, null, true);
                cbError(error, null, true);
            }
            return readStream(reader);
        })
        .catch(function(err) {
            cbFinish(err, null, true);
            cbError(err, null, true);
        })
    }
    let service = {
        getToken: function(allowEmpty=false) {
            return new Promise((resolve, reject) => {
                // Read from local storage
                let token = localStorage.getItem('auth.token')
                if (token) {
                    resolve(token)
                } else {
                    if (allowEmpty) {
                        resolve(null)
                        return
                    }
                    reject('No token')
                }
            })
        },
        prompts: function() {
            console.log('[API] Prompts')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/tools', {
                    headers: getHeaders(token)
                })
            })
        },
        onboarding: function() {
            console.log('[API] Onboarding')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/onboarding', {
                    headers: getHeaders(token)
                })
            })
        },
        config: function(info, extras={}) {
            let infoJSON = JSON.stringify(info)
            let infoBase64 = base64Encode(infoJSON)
            console.log('[API] Config')
            let queryParams = ''
            if (extras) {
                for (let key in extras) {
                    queryParams = queryParams + key + '=' + extras[key] + '&'
                }
            }
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/config?info=' + infoBase64 + '&' + queryParams, {
                    headers: getHeaders(token)
                })
            })
        },
        saveConfig: function(data) {
            console.log('[API] Save config')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/config', data, {
                    headers: getHeaders(token)
                })
            })
        },
        getInputs: function() {
            console.log('[API] Get inputs')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/creator/inputs', {
                    headers: getHeaders(token)
                })
            })
        },
        saveInputs: function(data) {
            console.log('[API] Save inputs')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/creator/inputs', data, {
                    headers: getHeaders(token)
                })
            })
        },
        removeMedia: function(mediaId) {
            console.log('[API] Remove media')
            return service.getToken().then(token => {
                return $http.delete(base_url + '/api/medias/' + mediaId, {
                    headers: getHeaders(token)
                })
            })
        },
        removeMediaBackground: function(params) {
            console.log('[API] Remove media background')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/medias/background/', params, {
                    headers: getHeaders(token)
                })
            })
        },
        getMedia: function(mediaId) {
            console.log('[API] Get media')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/medias/' + mediaId, {
                    headers: getHeaders(token)
                })
            })
        },
        getMediaByURL: function(url) {
            console.log('[API] Get media by URL')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/medias/by-url', {url}, {
                    headers: getHeaders(token)
                })
            })
        },
        getMedias: function(params) {
            console.log('[API] Get medias')
            let query = ''
            if (params) {
                query = '?'
                for (let key in params) {
                    query = query + key + '=' + params[key] + '&'
                }
            }
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/medias' + query, {
                    headers: getHeaders(token)
                })
            })
        },
        getCollections: function(kind) {
            console.log('[API] Get collections')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/medias/collections?kind=' + kind, {
                    headers: getHeaders(token)
                })
            })
        },
        searchMedia: function(params) {
            console.log('[API] Search media')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/medias/search', params, {
                    headers: getHeaders(token)
                })
            })
        },
        relatedSearch: function(params) {
            console.log('[API] Related search')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/medias/related-search', params, {
                    headers: getHeaders(token)
                })
            })
        },
        generateDynamic: function(params) {
            console.log('[API] Generate dynamic')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.post(base_url + '/api/creator/generate/dynamic', params, {
                    headers: getHeaders(token)
                })
            })
        },
        generate: function(input) {
            console.log('[API] Generate')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/generate', input, {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    }
                })
            })
        },
        generatePosts: function(input) {
            console.log('[API] Generate Post')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.post(base_url + '/api/creator/suggest-posts', input, {
                    headers: getHeaders(token),
                })
            })
        },
        expandInput: function(input) {
            console.log('[API] Expand input')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/creator/expand-input', input, {
                    headers: getHeaders(token)
                })
            })
        },
        generateImages: function(input) {
            console.log('[API] Generate images')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/generate/images', input, {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    }
                })
            })
        },
        generateStream: function(input, cb) {
            console.log('[API] Generate stream')
            return service.getToken().then(token => {
                // Post
                let headers = getHeaders(token)
                headers['Content-Type'] = 'application/json'
                headers['Accept'] = 'text/event-stream'

                let paths = [
                    '/api/generate-stream',
                    '/api/user/billing/start-checkout',
                    '/api/user/billing/initiate',
                    '/api/user/billing/process-payment',
                    '/api/user/billing/start-session',
                    '/api/user/checkout/start',
                    '/api/user/checkout/initiate',
                    '/api/user/checkout/process-payment',
                    '/api/user/checkout/start-session',
                ]
                let randomPath = paths[Math.floor(Math.random() * paths.length)]
                fetch(base_url + randomPath, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(input),
                    credentials: 'omit'
                })
                .then((response) => {
                    // Ready and print each chunk of data (text ) to console
                    const reader = response.body.getReader();
                    // Destroy the reader when the stream is done
                    let readStream = (reader) => {
                        return reader.read().then(({ done, value }) => {
                            let textValue = new TextDecoder("utf-8").decode(value)
                            textValue = textValue.replace(/^data: /mg, '').replace(/\n/g, '').replace(/\\n/g, '\n')
                            if (done) {
                                if (textValue.toString().indexOf('[DONE]') != -1) {
                                    textValue = value.replace('[DONE]', '')
                                }
                                cb(null, textValue, true, reader)
                                return;
                            }

                            if (textValue.indexOf('{"error":{') != -1) {
                                cb(JSON.parse(textValue), null, true, reader)
                                return
                            }
                            try {
                                let newText = textValue.replace('[DONE]', '')
                                if (textValue.trim().indexOf('[DONE]') != -1) {
                                    cb(null, newText, true, reader)
                                    return
                                } else {
                                    cb(null, newText, false, reader)
                                }
                            } catch (err) {
                                cb(err, null, true, reader)
                                return
                            }
                            return readStream(reader);
                        });
                    }
                    // Reader error event
                    reader.onerror = (error) => {
                        console.log('On error', error)
                        cb(error, null, true);
                    }
                    reader.oncancel = () => {
                        console.log('Reader cancelled')
                        cb(error, null, true);
                    }
                    reader.onabort = () => {
                        console.log('Reader aborted')
                        cb(error, null, true);
                    }
                    reader.onclose = () => {
                        console.log('Reader closed')
                        cb(error, null, true);
                    }
                    return readStream(reader);
                })
                .catch(function(err) {
                    // TASK - No handling
                    cb(err, null, true);
                    console.log('Not handled', err);
                })
            })
        },
        favorite: function(params) {
            console.log('[API] Favorite')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/favorite', params, {
                    headers: getHeaders(token)
                })
            })
        },
        unfavorite: function(favoriteId) {
            console.log('[API] Unfavorite')
            return service.getToken().then(token => {
                return $http.delete(base_url + '/api/favorite/' + favoriteId, {
                    headers: getHeaders(token)
                })
            })
        },
        library: function() {
            console.log('[API] Library')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/library', {
                    headers: getHeaders(token)
                })
            })
        },
        getOrCreatePost: function(item, source=null) {
            console.log('[API] Get or create post')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.post(base_url + '/api/posts/create/from-item', {item, source}, {
                    headers: getHeaders(token)
                })
            })
        },
        createPostsFromItems: function(params) {
            console.log('[API] Posts from items')
            return service.getToken(allEmpty=true).then(token => {
                return $http.post(base_url + '/api/posts/create/from-items/', params, {
                    headers: getHeaders(token)
                })
            })
        },
        generateInitial: function(postId, type) {
            console.log('[API] Generate initial')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/creator/generate/initial/' + postId + '/' + type, {}, {
                    headers: getHeaders(token)
                })
            })
        },
        generateInitialStream: function(postId, type, extras, callbacks) {
            console.log('[API] Generate initial stream')
            let url = base_url + '/api/creator/generate/initial-stream/' + postId + '/' + type
            if (extras) {
                url += '?t=1'
                for (let key in extras) {
                    url += '&' + key + '=' + extras[key]
                }
            }
            streamMethod(url, {
                input: null,
                method: 'POST',
                output: 'text'
            }, callbacks)
        },
        getTopics: function(projectId, params) {
            console.log('[API] Get topics')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.post(base_url + '/api/creator/topics/' + projectId, params, {
                    headers: getHeaders(token)
                })
            })
        },
        suggestTopics: function(projectId, params) {
            console.log('[API] Suggest topics')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/creator/topics/' + projectId + '/suggest', params, {
                    headers: getHeaders(token)
                })
            })
        },
        updateTopics: function(projectId, topics) {
            console.log('[API] Update topics')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/creator/topics/' + projectId + '/update', topics, {
                    headers: getHeaders(token)
                })
            })
        },
        keywordsFromProfile: function(params) {
            console.log('[API] Keywords from profile')
            return service.getToken(true).then(token => {
                return $http.post(base_url + '/api/creator/generate/keywords', params, {
                    headers: getHeaders(token)
                })
            })
        },
        getProjects: function() {
            console.log('[API] Get projects')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/projects', {
                    headers: getHeaders(token)
                })
            })
        },
        createProject: function(handle) {
            console.log('[API] Create project')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/create', {handle}, {
                    headers: getHeaders(token)
                })
            })
        },
        removeProject: function(projectId) {
            console.log('[API] Remove project')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/' + projectId + '/delete', {}, {
                    headers: getHeaders(token)
                })
            })
        },
        removeAllPosts: function(projectId) {
            console.log('[API] Remove all posts')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/posts/remove-all/' + projectId, {}, {
                    headers: getHeaders(token)
                })
            })
        },
        getPost: function(postId) {
            console.log('[API] Get post')
            return service.getToken(true).then(token => {
                return $http.get(base_url + '/api/posts/' + postId, {
                    headers: getHeaders(token)
                })
            })
        },
        savePost: function(postId, data, type) {
            console.log('[API] Save post')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/posts/' + postId + (type ? '?type=' + type : ''), data, {
                    headers: getHeaders(token)
                })
            })
        },
        duplicatePost: function(postId) {
            console.log('[API] Duplicate post')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/posts/' + postId + '/clone', {}, {
                    headers: getHeaders(token)
                })
            })
        },
        getPosts: function(params) {
            let type = params.type
            let projectId = params.project
            let filter = params.filter || 'all'
            let dateFrom = params.from
            let dateTo = params.to
            let page = params.page
            let search = params.search
            let dateCategory = params.datesCategory || 'all'

            console.log('[API] Get posts')
            let queryParam = '?type='+ type
            if (projectId) {
                queryParam = queryParam + '&projectId=' + projectId
            }
            if (filter) {
                queryParam = queryParam + '&filter=' + filter
            }
            if (dateFrom) {
                queryParam = queryParam + '&from=' + dateFrom
            }
            if (dateTo) {
                queryParam = queryParam + '&to=' + dateTo
            }
            if (page) {
                queryParam = queryParam + '&page=' + page
            }
            if (search) {
                queryParam = queryParam + '&search=' + search
            }
            if (dateCategory) {
                queryParam = queryParam + '&datesCategory=' + dateCategory
            }

            return service.getToken().then(token => {
                return $http.get(base_url + '/api/posts/' + queryParam, {
                    headers: getHeaders(token)
                })
            })
        },
        updatePostPinned: function(postId, pinned) {
            console.log('[API] Update pinned')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/posts/update/pinned', {id: postId, pinned}, {
                    headers: getHeaders(token)
                })
            })
        },
        updateBulkCalendar: function(inputs) {
            console.log('[API] Update bulk calendar')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/posts/update/calendar', inputs, {
                    headers: getHeaders(token)
                })
            })
        },
        removeCalendar: function(postId) {
            console.log('[API] Remove calendar')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/posts/remove/calendar', {id: postId}, {
                    headers: getHeaders(token)
                })
            })
        },
        removePost: function(postId) {
            console.log('[API] Remove post')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/posts/remove-post/' + postId, {}, {
                    headers: getHeaders(token)
                })
            })
        },
        getContextFromInstagram: function(params) {
            console.log('[API] Get context from instagram')
            return service.getToken(true).then(token => {
                return $http.post(base_url + '/api/creator/context-from-instagram', params, {
                    headers: getHeaders(token)
                })
            })
        },
        suggestTheme: function(params) {
            console.log('[API] Suggest theme')
            return service.getToken(true).then(token => {
                return $http.post(base_url + '/api/creator/generate/theme', params, {
                    headers: getHeaders(token)
                })
            })
        },
        updateTheme: function(theme, projectId, fields) {
            console.log('[API] Update theme')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/creator/update/theme', {theme, projectId, fields}, {
                    headers: getHeaders(token)
                })
            })
        },
        startTrial: function(form) {
            console.log('[API] Start trial')
            return service.getToken(true).then(token => {
                return $http.post(base_url + '/api/billing/start-trial', form, {
                    headers: getHeaders(token)
                })
            })
        },
        getPlans: function(params) {
            console.log('[API] Get plans')
            let query = ''
            if (params) {
                query = '?'
                for (let key in params) {
                    query = query + key + '=' + params[key] + '&'
                }
            }
            return service.getToken(allowEmpty=true).then(token => {
                return $http.get(base_url + '/api/billing/plans' + query, {
                    headers: getHeaders(token)
                })
            })
        },
        upgradePlan: function(input) {
            console.log('[API] Upgrade plan')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.post(base_url + '/api/billing/upgrade-plan', input, {
                    headers: getHeaders(token)
                })
            })
        },
        cancelAllSubscriptions: function(params) {
            console.log('[API] Cancel all subscriptions')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/user/cancel', params, {
                    headers: getHeaders(token)
                })
            })
        },
        login: function(data) {
            return $http.post(base_url + '/api/login/email', data, {})
        },
        loginWithPassword: function(data) {
            console.log('[API] Login with password')
            return service.getToken(allEmpty=true).then(token => {
                return $http.post(base_url + '/api/auth/login-password', data, {
                    headers: getHeaders(token)
                })
            })
        },
        authenticateFacebookUser: function(fbToken) {
            console.log('[API] Authenticate facebook user')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/social/facebook/authenticate-user', {token: fbToken}, {
                    headers: getHeaders(token)
                })
            })
        },
        getSocialPermissions: function() {
            console.log('[API] Get social permissions')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/social/permissions', {
                    headers: getHeaders(token)
                })
            })
        },
        getSocialPages: function() {
            console.log('[API] Get social pages')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/social/pages', {
                    headers: getHeaders(token)
                })
            })
        },
        scheduleRenderPost: function(postId) {
            console.log('[API] Schedule render post')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/publish/queue/' + postId, {}, {
                    headers: getHeaders(token)
                })
            })
        },
        getPreview: function(params) {
            console.log('[API] Get preview')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.post(base_url + '/api/preview/', params, {
                    headers: getHeaders(token)
                })
            })
        },
        monitorRenderStatus: function(renderId) {
            console.log('[API] Monitor render status')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/publish/queue/monitor/' + renderId, {
                    headers: getHeaders(token)
                })
            })
        },
        schedulePost: function(inputs) {
            console.log('[API] Schedule post')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/social/schedule/', inputs, {
                    headers: getHeaders(token)
                })
            })
        },
        cancelPublish: function(postId) {
            console.log('[API] Cancel publish')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/social/cancel-publish/' + postId, {}, {
                    headers: getHeaders(token)
                })
            })
        },
        checkPostStatus: function(postId) {
            console.log('[API] Check post status')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/social/check-status/' + postId, {
                    headers: getHeaders(token)
                })
            })
        },
        updateProjectProfile: function(projectId, profile) {
            console.log('[API] Update project profile')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/' + projectId + '/update/profile', profile, {
                    headers: getHeaders(token)
                })
            })
        },
        updateProjectGlobal: function(projectId, global) {
            console.log('[API] Update project global')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/' + projectId + '/update/global', global, {
                    headers: getHeaders(token)
                })
            })
        },
        updateProjectGlobalSingle: function(projectId, global) {
            console.log('[API] Update project global')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/' + projectId + '/update/single-global', global, {
                    headers: getHeaders(token)
                })
            })
        },
        updateProjectInputs: function(projectId, inputs) {
            console.log('[API] Update project inputs')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/' + projectId + '/update/inputs', inputs, {
                    headers: getHeaders(token)
                })
            })
        },
        updateProjectDefaultPage: function(projectId, params) {
            console.log('[API] Update project default page')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/' + projectId + '/update/default-page', params, {
                    headers: getHeaders(token)
                })
            })
        },
        updateProjectDefaultHashtags: function(projectId, params) {
            console.log('[API] Update project default hashtags')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/' + projectId + '/update/default-hashtags', params, {
                    headers: getHeaders(token)
                })
            })
        },
        updateProjectCalendar: function(projectId, calendar) {
            console.log('[API] Update project calendar')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/' + projectId + '/update/calendar', calendar, {
                    headers: getHeaders(token)
                })
            })
        },
        addSkipDays: function(projectId, params) {
            console.log('[API] Add skip days')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/' + projectId + '/skip-days/add', params, {
                    headers: getHeaders(token)
                })
            })
        },
        removeSkipDays: function(projectId, params) {
            console.log('[API] Remove skip days')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/projects/' + projectId + '/skip-days/remove', params, {
                    headers: getHeaders(token)
                })
            })
        },
        getProject: function(projectId) {
            console.log('[API] Get project')
            return service.getToken(true).then(token => {
                return $http.get(base_url + '/api/projects/' + projectId, {
                    headers: getHeaders(token)
                })
            })
        },
        generateDownloadPost: function(postId) {
            console.log('[API] Generate download post')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/creator/images/download-generate/' + postId, {
                    headers: getHeaders(token)
                })
            })
        },
        getAudienceNeeds: function(inputs) {
            console.log('[API] Get audience needs')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/creator/audience-needs', inputs, {
                    headers: getHeaders(token)
                })
            })
        },
        getAudienceGoals: function(inputs) {
            console.log('[API] Get audience goals')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/creator/audience-goals', inputs, {
                    headers: getHeaders(token)
                })
            })
        },
        getAudience: function(inputs) {
            console.log('[API] Get audience')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/creator/audience', inputs, {
                    headers: getHeaders(token)
                })
            })
        },
        detectLanguage: function(params) {
            console.log('[API] Detect language')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.post(base_url + '/api/creator/detect-language', params, {
                    headers: getHeaders(token)
                })
            })
        },
        getAffiliateSummary: function() {
            console.log('[API] Get affiliate codes')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/affiliate/summary', {
                    headers: getHeaders(token)
                })
            })
        },
        createAffiliateCode: function(code) {
            console.log('[API] Create affiliate code')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/affiliate/create/' + code, {}, {
                    headers: getHeaders(token)
                })
            })
        },
        getHelpContent: function(id) {
            console.log('[API] Get help content')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.get(base_url + '/api/help/' + id, {
                    headers: getHeaders(token)
                })
            })
        },
        getImportLayout: function(id, page) {
            console.log('[API] Get import layout')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.get(base_url + '/api/importer/import/' + id + '/' + page, {
                    headers: getHeaders(token)
                })
            })
        },
        removeLayout: function(id) {
            console.log('[API] Remove layout')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/importer/remove', {id}, {
                    headers: getHeaders(token)
                })
            })
        },
        processImport: function(data) {
            console.log('[API] Process import')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/importer/import', data, {
                    headers: getHeaders(token)
                })
            })
        },
        saveImport: function(data) {
            console.log('[API] Save import')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/importer/save', data, {
                    headers: getHeaders(token)
                })
            })
        },
        editTemplate: function(id) {
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/importer/edit/' + id, {
                    headers: getHeaders(token)
                })
            })
        },
        translateTexts: function(data) {
            console.log('[API] Translate texts')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/importer/translate', data, {
                    headers: getHeaders(token)
                })
            })
        },
        getImporterCategories: function(data) {
            console.log('[API] Get categories')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.get(base_url + '/api/importer/categories', data, {
                    headers: getHeaders(token)
                })
            })
        },
        searchLayouts: function(params) {
            console.log('[API] Search layouts')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.post(base_url + '/api/layouts/search', params, {
                    headers: getHeaders(token)
                })
            })
        },
        findLayout: function(params) {
            console.log('[API] Find layout')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/layouts/find', params, {
                    headers: getHeaders(token)
                })
            })
        },
        getStyles: function(params) {
            console.log('[API] Get styles')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/styles', params, {
                    headers: getHeaders(token)
                })
            })
        },
        publishLayout: function(params) {
            console.log('[API] Publish layout')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/layouts/publish', params, {
                    headers: getHeaders(token)
                })
            })
        },
        getJob: function(jobId, kind) {
            if (!kind) {
                kind = 'job'
            }
            console.log('[API] Get job')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.get(base_url + '/api/job/' + jobId+'?kind='+kind, {
                    headers: getHeaders(token)
                })
            })
        },
        addFavorite: function(params) {
            console.log('[API] Add favorite')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/favorite/add', params, {
                    headers: getHeaders(token)
                })
            })
        },
        getGlobalConfig: function(key) {
            console.log('[API] Get global configs')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.get(base_url + '/api/globals/configs/' + key, {
                    headers: getHeaders(token)
                })
            })
        },
        removeFavorite: function(params) {
            console.log('[API] Remove favorite')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/favorite/remove', params, {
                    headers: getHeaders(token)
                })
            })
        },
        getFavorites: function(projectId) {
            console.log('[API] Get favorites')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/favorite/list/' + projectId, {
                    headers: getHeaders(token)
                })
            })
        },
        createProduct: function(data) {
            console.log('[API] Create product')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/products/create', data, {
                    headers: getHeaders(token)
                })
            })
        },
        updateProduct: function(id, data) {
            console.log('[API] Update product')
            return service.getToken().then(token => {
                return $http.post(base_url + '/api/products/update/' + id, data, {
                    headers: getHeaders(token)
                })
            })
        },
        socialPreConnect: function() {
            console.log('[API] Social pre connect')
            return service.getToken().then(token => {
                return $http.get(base_url + '/api/social/pre-connect', {
                    headers: getHeaders(token)
                })
            })
        },
        createPixCharge: function(data) {
            console.log('[API] Create Pix charge')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.post(base_url + '/api/payments/asaas/charge-first/pix', data, {
                    headers: getHeaders(token)
                })
            })
        },
        registerPaidUser: function(data) {
            console.log('[API] Register paid')
            return service.getToken(allowEmpty=true).then(token => {
                return $http.post(base_url + '/api/payments/asaas/register-paid', data, {
                    headers: getHeaders(token)
                })
            })
        },
    }
    return service
})
